import actionTypes from './actionTypes';

const INITIAL_STATE = {
  menuItemsLoading: false,
  menuItemsFailed: false,
  menuItemsError: false,
  menuItemsMessage: null,
  menuItems: {},
  menuItemsList: [],

  changeMenuItemStatusLoading: false,
  changeMenuItemStatusFailed: false,
  changeMenuItemStatusError: false,
  changeMenuItemStatusMessage: null,

  deletedMenuItemsLoading: false,
  deletedMenuItemsFailed: false,
  deletedMenuItemsError: false,
  deletedMenuItemsMessage: null,
  deletedMenuItems: {},
  deletedMenuItemsList: [],

  menuItemDetailsLoading: false,
  menuItemDetailsFailed: false,
  menuItemDetailsError: false,
  menuItemDetailsMessage: null,
  menuItemDetails: {},

  deleteMenuItemLoading: false,
  deleteMenuItemFailed: false,
  deleteMenuItemError: false,
  deleteMenuItemMessage: null,


  insertNewMenuItemLoading: false,
  insertNewMenuItemFailed: false,
  insertNewMenuItemError: false,
  insertNewMenuItemMessage: null,


  editMenuItemLoading: false,
  editMenuItemFailed: false,
  editMenuItemError: false,
  editMenuItemMessage: null,


  getMenuItemImagesLoading: false,
  getMenuItemImagesFailed: false,
  getMenuItemImagesError: false,
  getMenuItemImagesMessage: '',
  menuItemImages: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_MENU_ITEMS_LOADING: {
      return {
        ...state,
        menuItemsLoading: true,
        menuItemsFailed: false,
        menuItemsError: false,
        menuItemsMessage: null,
        menuItemsList: [],
        menuItems: {}
      };
    }
    case actionTypes.FETCH_ALL_MENU_ITEMS_SUCCESS: {
      return {
        ...state,
        menuItemsLoading: false,
        menuItemsFailed: false,
        menuItemsError: false,
        menuItemsMessage: null,
        menuItems: { ...action.payload },
        menuItemsList: [...action.payload.menuItems],
      };
    }
    case actionTypes.FETCH_ALL_MENU_ITEMS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        menuItemsLoading: false,
        menuItemsFailed: true,
        menuItemsError: false,
        menuItemsMessage: message,
        menuItemsList: [],
        menuItems: {}
      };
    }
    case actionTypes.FETCH_ALL_MENU_ITEMS_REJECT: {
      return {
        ...state,
        menuItemsLoading: false,
        menuItemsFailed: false,
        menuItemsError: true,
        menuItemsMessage: null,
        menuItemsList: [],
        menuItems: {}
      };
    }


    case actionTypes.CHANGE_MENU_ITEM_STATUS_LOADING: {
      return {
        ...state,
        changeMenuItemStatusLoading: true,
        changeMenuItemStatusFailed: false,
        changeMenuItemStatusError: false,
        changeMenuItemStatusMessage: null,
      };
    }
    case actionTypes.CHANGE_MENU_ITEM_STATUS_SUCCESS: {
      return {
        ...state,
        changeMenuItemStatusLoading: false,
        changeMenuItemStatusFailed: false,
        changeMenuItemStatusError: false,
        changeMenuItemStatusMessage: null,
        menuItemsList: action.payload,
      };
    }
    case actionTypes.CHANGE_MENU_ITEM_STATUS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        changeMenuItemStatusLoading: false,
        changeMenuItemStatusFailed: true,
        changeMenuItemStatusError: false,
        changeMenuItemStatusMessage: message,
      };
    }
    case actionTypes.CHANGE_MENU_ITEM_STATUS_REJECT: {
      return {
        ...state,
        changeMenuItemStatusLoading: false,
        changeMenuItemStatusFailed: false,
        changeMenuItemStatusError: true,
        changeMenuItemStatusMessage: null,
      };
    }


    case actionTypes.DELETE_MENU_ITEM_LOADING: {
      return {
        ...state,
        deleteMenuItemLoading: true,
        deleteMenuItemFailed: false,
        deleteMenuItemError: false,
        deleteMenuItemMessage: null,
      };
    }
    case actionTypes.DELETE_MENU_ITEM_SUCCESS: {
      return {
        ...state,
        deleteMenuItemLoading: false,
        deleteMenuItemFailed: false,
        deleteMenuItemError: false,
        deleteMenuItemMessage: null,
      };
    }
    case actionTypes.DELETE_MENU_ITEM_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        deleteMenuItemLoading: false,
        deleteMenuItemFailed: true,
        deleteMenuItemError: false,
        deleteMenuItemMessage: message,
      };
    }
    case actionTypes.DELETE_MENU_ITEM_REJECT: {
      return {
        ...state,
        deleteMenuItemLoading: false,
        deleteMenuItemFailed: false,
        deleteMenuItemError: true,
        deleteMenuItemMessage: null,
      };
    }


    case actionTypes.FETCH_MENU_ITEM_BY_ID_LOADING: {
      return {
        ...state,
        menuItemDetailsLoading: true,
        menuItemDetailsFailed: false,
        menuItemDetails: {},
        menuItemDetailsError: false,
        menuItemDetailsMessage: null,

        insertNewMenuItemLoading: false,
        insertNewMenuItemFailed: false,
        insertNewMenuItemError: false,
        insertNewMenuItemMessage: null,


        editMenuItemLoading: false,
        editMenuItemFailed: false,
        editMenuItemError: false,
        editMenuItemMessage: null,
      };
    }
    case actionTypes.FETCH_MENU_ITEM_BY_ID_SUCCESS: {
      return {
        ...state,
        menuItemDetailsLoading: false,
        menuItemDetailsFailed: false,
        menuItemDetailsError: false,
        menuItemDetailsMessage: null,
        menuItemDetails: { ...action.payload },

        insertNewMenuItemLoading: false,
        insertNewMenuItemFailed: false,
        insertNewMenuItemError: false,
        insertNewMenuItemMessage: null,


        editMenuItemLoading: false,
        editMenuItemFailed: false,
        editMenuItemError: false,
        editMenuItemMessage: null,
      };
    }
    case actionTypes.FETCH_MENU_ITEM_BY_ID_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        menuItemDetailsLoading: false,
        menuItemDetails: {},
        menuItemDetailsFailed: true,
        menuItemDetailsError: false,
        menuItemDetailsMessage: message,

        insertNewMenuItemLoading: false,
        insertNewMenuItemFailed: false,
        insertNewMenuItemError: false,
        insertNewMenuItemMessage: null,


        editMenuItemLoading: false,
        editMenuItemFailed: false,
        editMenuItemError: false,
        editMenuItemMessage: null,
      };
    }
    case actionTypes.FETCH_MENU_ITEM_BY_ID_REJECT: {
      return {
        ...state,
        menuItemDetailsLoading: false,
        menuItemDetailsFailed: false,
        menuItemDetailsError: true,
        menuItemDetailsMessage: null,
        menuItemDetails: {},

        insertNewMenuItemLoading: false,
        insertNewMenuItemFailed: false,
        insertNewMenuItemError: false,
        insertNewMenuItemMessage: null,


        editMenuItemLoading: false,
        editMenuItemFailed: false,
        editMenuItemError: false,
        editMenuItemMessage: null,
      };
    }

    case actionTypes.FETCH_ALL_DELETED_MENU_ITEMS_LOADING: {
      return {
        ...state,
        deletedMenuItemsLoading: true,
        deletedMenuItemsFailed: false,
        deletedMenuItemsError: false,
        deletedMenuItemsMessage: null,
        deletedMenuItemsList: [],
        deletedMenuItems: {}
      };
    }
    case actionTypes.FETCH_ALL_DELETED_MENU_ITEMS_SUCCESS: {
      return {
        ...state,
        deletedMenuItemsLoading: false,
        deletedMenuItemsFailed: false,
        deletedMenuItemsError: false,
        deletedMenuItemsMessage: null,
        deletedMenuItems: { ...action.payload },
        deletedMenuItemsList: [...action.payload.menuItems],
      };
    }
    case actionTypes.FETCH_ALL_DELETED_MENU_ITEMS_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        deletedMenuItemsLoading: false,
        deletedMenuItemsFailed: true,
        deletedMenuItemsError: false,
        deletedMenuItemsMessage: message,
        deleteMenuItemsList: [],
        deletedMenuItems: {}
      };
    }
    case actionTypes.FETCH_ALL_DELETED_MENU_ITEMS_REJECT: {
      return {
        ...state,
        deletedMenuItemsLoading: false,
        deletedMenuItemsFailed: false,
        deletedMenuItemsError: true,
        deletedMenuItemsMessage: null,
        menuItemsList: [],
        deletedMenuItems: {}
      };
    }


    case actionTypes.INSERT_NEW_MENU_ITEM_LOADING: {
      return {
        ...state,
        insertNewMenuItemLoading: true,
        insertNewMenuItemFailed: false,
        insertNewMenuItemError: false,
        insertNewMenuItemMessage: null,
      };
    }
    case actionTypes.INSERT_NEW_MENU_ITEM_SUCCESS: {
      return {
        ...state,
        insertNewMenuItemLoading: false,
        insertNewMenuItemFailed: false,
        insertNewMenuItemError: false,
        insertNewMenuItemMessage: null,
      };
    }
    case actionTypes.INSERT_NEW_MENU_ITEM_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        insertNewMenuItemLoading: false,
        insertNewMenuItemFailed: true,
        insertNewMenuItemError: false,
        insertNewMenuItemMessage: message,
      };
    }
    case actionTypes.INSERT_NEW_MENU_ITEM_REJECT: {
      return {
        ...state,
        insertNewMenuItemLoading: false,
        insertNewMenuItemFailed: false,
        insertNewMenuItemError: true,
        insertNewMenuItemMessage: null,
      };
    }

    case actionTypes.UPDATE_MENU_ITEM_LOADING: {
      return {
        ...state,
        editMenuItemLoading: true,
        editMenuItemFailed: false,
        editMenuItemError: false,
        editMenuItemMessage: null,
      };
    }
    case actionTypes.UPDATE_MENU_ITEM_SUCCESS: {
      return {
        ...state,
        editMenuItemLoading: false,
        editMenuItemFailed: false,
        editMenuItemError: false,
        editMenuItemMessage: null,
        menuItemsList: action.payload,
      };
    }
    case actionTypes.UPDATE_MENU_ITEM_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        editMenuItemLoading: false,
        editMenuItemFailed: true,
        editMenuItemError: false,
        editMenuItemMessage: message,
      };
    }
    case actionTypes.UPDATE_MENU_ITEM_REJECT: {
      return {
        ...state,
        editMenuItemLoading: false,
        editMenuItemFailed: false,
        editMenuItemError: true,
        editMenuItemMessage: null,
      };
    }

    case actionTypes.GET_MENU_ITEM_IMAGES_LOADING: {
      return {
        ...state,
        getMenuItemImagesLoading: true,
        getMenuItemImagesFailed: false,
        getMenuItemImagesError: false,
        getMenuItemImagesMessage: '',
        menuItemImages: [],
      };
    }
    case actionTypes.GET_MENU_ITEM_IMAGES_SUCCESS: {
      return {
        ...state,
        getMenuItemImagesLoading: false,
        getMenuItemImagesFailed: false,
        getMenuItemImagesError: false,
        getMenuItemImagesMessage: '',
        menuItemImages: action.payload.menuImages,
      };
    }
    case actionTypes.GET_MENU_ITEM_IMAGES_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getMenuItemImagesLoading: false,
        getMenuItemImagesFailed: true,
        getMenuItemImagesError: false,
        getMenuItemImagesMessage: message,
        menuItemImages: [],
      };
    }
    case actionTypes.GET_MENU_ITEM_IMAGES_REJECT: {
      return {
        ...state,
        getMenuItemImagesLoading: false,
        getMenuItemImagesFailed: false,
        getMenuItemImagesError: true,
        getMenuItemImagesMessage: '',
        menuItemImages: [],
      };
    }
    default:
      return state;
  };
};
